/** GMCIAMTEST (Entra External ID) — US main; dedicated Entra preprod app (not the B2C test client). */
const domain = 'ciamlogin.pp.gm.com'
const tenantId = '1b84deee-7bd0-4f65-9659-6f620dcac84a'
/** Not used for Entra External ID; kept for NavConfig shape. */
const policy = ''

export const MSalEntraNaTestConfig = {
	approvedAuthorities: [domain],
	/** Tenant root only — MSAL appends `/v2.0` for OIDC metadata (do not include `/v2.0` here). */
	authority: `https://${domain}/${tenantId}`,
	clientID: '339df9b4-9230-4d65-b4cc-f4ee5759a1b3',
	policy,
	tenant: domain,
}
